import React from 'react';
import '../../Assets/css/generativeLoaderStyle.css';

const colors = [
  '#240046',
  '#3c096c',
  '#5a189a',
  '#7b2cbf',
  '#9d4edd',
  '#c77dff',
  '#e0aaff',
];

const GenerativeLoader: React.FC = () => {
  return (
    <div
      className="loader"
      style={
        {
          '--animationSpeed': '2s',
          '--circlesCount': 7,
        } as React.CSSProperties
      }
    >
      {Array.from({ length: 7 }).map((_, index) => (
        <div
          key={index}
          className="circle"
          style={
            {
              '--color': colors[index % colors.length],
              '--index': index,
            } as React.CSSProperties
          }
        ></div>
      ))}
    </div>
  );
};

export default GenerativeLoader;
